export const REQUIRED_COLUMNS = [
  "first_name",
  "last_name",
  "email"
]

export const COL_TOOLTIP_MAP = {
  "first_name": "First name of the user",
  "last_name": "Last name of user",
  "email": "Email address of user",
}